export default __webpack_public_path__ + "static/media/topic-user.d028c5b1.svg";